import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';

export interface ScriptTemplate {
  id: string;
  key: string;
  modelDocumentPath: string;
  schema: unknown;
  organizationId?: string | null;
}

export class ToolsTemplatesService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/templates`, client.getTimeout());
  }

  async getByOrganization(organizationId: string, request?: { settings?: RetrySettings }): Promise<ScriptTemplate[]> {
    const response = await this.client.get<ScriptTemplate[]>(
      `organizations/${organizationId}`,
      {},
      {
        bearerToken: await getAuthToken(),
        settings: request?.settings,
      },
    );
    return response.data;
  }
}
